// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"d7d923402b7d8ed18fd8","532":"f0d75f51e396ab4153a6","678":"b27925d4b5abfa8930b1","883":"7a2c366f3a627c36139c"}[chunkId] + ".js";
};